import { EnrolmentClaim } from '../../../routes/enrolment/models/enrolment-claim';
import { createAction, props } from '@ngrx/store';

export const PAGE_SIZE = 20;

export const getRevocableEnrolments = createAction(
  '[REVOCABLE ENROLMENTS] Get Enrolments',
  props<{ skip: number; take: number }>()
);

export const getLastRevocableEnrolments = createAction(
  '[REVOCABLE ENROLMENTS] Get Last Enrolments'
);

export const getRevocableEnrolmentsSuccess = createAction(
  '[REVOCABLE ENROLMENTS] Get Enrolments Success',
  props<{
    enrolments: EnrolmentClaim[];
    skip: number;
    take: number;
    hasNextPage: boolean;
  }>()
);

export const getRevocableEnrolmentsFailure = createAction(
  '[REVOCABLE ENROLMENTS] Get Revocable Enrolments Failure',
  props<{ error: string }>()
);

export const updateRevocableEnrolments = createAction(
  '[REVOCABLE ENROLMENTS] Update Revocable Enrolments'
);

export const updateRevocableEnrolmentsSuccess = createAction(
  '[REVOCABLE ENROLMENTS] Update Revocable Enrolments Success',
  props<{ enrolments: EnrolmentClaim[]; hasNextPage: boolean }>()
);

export const updateRevocableEnrolmentsFailure = createAction(
  '[REVOCABLE ENROLMENTS] Update Revocable Enrolments Failure',
  props<{ error: string }>()
);

export const updateEnrolment = createAction(
  '[REVOCABLE ENROLMENTS] Update Enrolment',
  props<{ id: string }>()
);

export const updateEnrolmentSuccess = createAction(
  '[REVOCABLE ENROLMENTS] Update Enrolment Success',
  props<{ enrolment: EnrolmentClaim }>()
);

export const updateEnrolmentFailure = createAction(
  '[REVOCABLE ENROLMENTS] Update Enrolment Failure',
  props<{ error: string }>()
);
